module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-011"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_vm._v("SERVANTS OF GOD"), _c('br'), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=1%20Corinthians+3:5-10&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("1 CORINTHIANS 3:5-10")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW: ")])]), _vm._v("Only one who is planted in the Lord’s house, the doctrines of the church, will bring forth flower and fruit (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("). In this process only God gives growth (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE, ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER, ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR")]), _vm._v("). God the Spirit gives life even where there is not yet a visible baptism, as in the case of martyrs (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER")]), _vm._v("). Differing gifts and tasks may be inspired by the one Spirit. The unity of God’s building is protected against splitting by the boundaries of ecumenical consent (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v("). What we build now must cohere with the foundation (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER")]), _vm._v("). Christ is the only foundation (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v("), which must be preserved, not overthrown (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR")]), _vm._v("). We are not slaves but God’s fellow workers in our preaching (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE OF ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPSUESTIA")]), _vm._v("). The poison of pride is resisted with the medicine of true humility (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESARIUS OF ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RLES")]), _vm._v("). It is a great thing to be a servant so as to be used by God to bring others to faith, but compared with the root of all good, this is nothing (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM, ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS")]), _vm._v("). Paul wants to avoid the temptation to idleness that results when everybody is treated as though equal in virtue (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM, ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER, ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS")]), _vm._v(").")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-090"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("3:5 "), _c('i', [_vm._v("Servants Through Whom They Believed")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("POLLOS AND ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL AS ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERVANTS.")])]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS: ")]), _vm._v("If Paul and Apollos counted for nothing, what can we say about those who glory in the flesh? C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 3.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN182",
      "id": "ap_NFIN182-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REACHING AND ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERVING.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Paul denigrates himself in order to show the Corinthians that he is not mistreating them. It is a great thing to be a servant, used by God to bring others to faith, but compared with the source and the root of all good, it is nothing. Note also that Paul called Apollos and himself servants, not evangelists. This is because they had not merely preached the gospel, but they had also ministered to the people at Corinth. The first was a matter of word only, whereas the second includes deeds as well. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 8.5.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN183",
      "id": "ap_NFIN183-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-091"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("3:6 "), _c('i', [_vm._v("God Gave the Growth")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVES ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROWTH.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("To plant is to evangelize and to bring to faith, to water is to baptize with the approved form of words. To forgive sins, however, and to give the Spirit belongs to God alone. We know that the Holy Spirit is given by God without the laying on of hands, and it has happened that an unbaptized person has received the forgiveness of his sins. Was such a person invisibly baptized, considering that he received the gift which belongs to baptism? C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN184",
      "id": "ap_NFIN184-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTTING ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWN ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOTS IN THE ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUSE OF THE ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD.")])]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME: ")]), _vm._v("I have been planted in the house of the Lord, I mean in the church; not in the walls but in its doctrines. Everyone who has been planted in the house of the Lord, who has put down roots there, brings forth flowers. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILY 21.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN185",
      "id": "ap_NFIN185-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFFERING ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFTS.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Paul and Apollos had different functions, but everything they did was of God. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 8.5.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN186",
      "id": "ap_NFIN186-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-092"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("3:7 "), _c('i', [_vm._v("Only God Is Anything")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LANTERS AND ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATERERS ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RE ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTHING.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("In relation to God’s honor, human honor is nothing. As far as the ministry is concerned, a man may be honored in the way that a servant is honored. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN187",
      "id": "ap_NFIN187-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NLY ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVES ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCREASE.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("Since the apostles would not have accomplished "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("anything if God had not given the increase, how much more true is this of you or me, or anyone else of our time, who fancies himself as a teacher. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER 193.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN188",
      "id": "ap_NFIN188-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABOR IN ")]), _vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AIN.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("Our labor is in vain without the help of God. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 180.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN189",
      "id": "ap_NFIN189-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-093"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("3:8 "), _c('i', [_vm._v("Receiving Wages According to Labor")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATER ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EWARD.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("Even though they are equal, the one who preaches the gospel is still greater than the one who baptizes and will receive a greater reward. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN190",
      "id": "ap_NFIN190-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRED ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANDS.")])]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS: ")]), _vm._v("Paul points out that he and Apollos are merely hired hands on someone else’s farm. They have nothing apart from the payment they get for their labor. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN191",
      "id": "ap_NFIN191-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VOIDING THE ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMPTATION TO ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DLENESS.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Paul says this in order to show that the Corinthians have no reason to think that some of them are superior to others. He did not allow those who worked hard to regard themselves as superior to those who did less, nor did he permit the latter to be jealous of the former. But in order to avoid the temptation to idleness which naturally results when everybody is treated equally, whether they have worked hard or not, Paul adds that the rewards will be distributed to each one according to the work accomplished. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 8.6.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN192",
      "id": "ap_NFIN192-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-094"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("3:9 "), _c('i', [_vm._v("Fellow Workers")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NITY OF ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UILDING.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("The building does not belong to the workman but to the master. If you are a building, you must not be split in two, since then the building will collapse. If you are a farm, you must not be divided but rather surrounded with a single fence, the fence of unanimity. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 8.6.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN193",
      "id": "ap_NFIN193-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORKERS ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RE ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAVES.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE OF ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPSUESTIA: ")]), _vm._v("Paul calls us God’s fellow workers, not his servants or slaves. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AULINE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY FROM THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN194",
      "id": "ap_NFIN194-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDICINE OF ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMILITY.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESARIUS OF ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RLES: ")]), _vm._v("Coworkers of God are those who, when once they see the poison of pride creeping into the heart of a brother, with all haste try to destroy it with the medicine of true humility. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMON 233.6.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN195",
      "id": "ap_NFIN195-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-095"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("3:10 "), _c('i', [_vm._v("Laying a Foundation")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UILD ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPERLY ON THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNDATION.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("This warning applies to you and me as well. If I do not build properly on the foundation already laid for me, then the fire will consume my work on the day of judgment. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON 1 ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 1.15.18-20.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN196",
      "id": "ap_NFIN196-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UILD ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHERES WITH THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNDATION.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("The wise master builder is one who preaches the same gospel as that which was preached by the Savior. Afterward other people build on the foundation, sometimes well and sometimes badly. We need to pay attention to make sure that what we build coheres with the foundation, because if it is crooked or lightweight it will collapse, though the foundation itself will remain intact. Even when people have taught badly, the name of Christ endures, because it is the foundation, although the bad teaching collapses. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN197",
      "id": "ap_NFIN197-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNDATION.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Paul is not exalting himself by taking the example of a skilled master builder, because whatever skill he possesses comes entirely from the grace of God that has been given to him. Furthermore, because it is grace, it is not divided but rests securely on the one foundation, which is Christ. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 8.6.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN198",
      "id": "ap_NFIN198-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESERVING THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNDATION.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("We need to build on the foundation, not overthrow it. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 181.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN199",
      "id": "ap_NFIN199-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6895f768","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap12.vue
// module id = 114
// module chunks = 0